import { type CSSObject } from "@mui/material/styles";

/**
 * `props.size` is **not type-checked** by MUI here: a misspelled size compiles and matches nothing,
 * which is why both callers have a test matrix that measures every size.
 */
export const sizeVariants = <Size extends string>(
  sizes: Record<Size, unknown>,
  styleFor: (size: Size) => CSSObject,
) => (Object.keys(sizes) as Size[]).map((size) => ({ props: { size }, style: styleFor(size) }));

/**
 * The colour stays the caller's so a ring can name the palette slot it follows — `primary.main` for
 * the generic one. A baked-in colour is a copy of a slot, and it drifts the moment the palette moves.
 */
export const focusRing = (color: string, width = 2) => `0 0 0 ${width}px ${color}`;
